import { render, staticRenderFns } from "./ProtocoloForm.vue?vue&type=template&id=6f01cf50&"
import script from "./ProtocoloForm.vue?vue&type=script&lang=js&"
export * from "./ProtocoloForm.vue?vue&type=script&lang=js&"
import style0 from "./ProtocoloForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports